import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  contractType?: string | null
}

const ContractType = ({ contractType }: Props) => {
  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s8">
      <Box alignItems="center" flexDirection="row" height="s24">
        <Text size="200" weight="normal" color="grey800">
          {i18n.t('contract_versions.contract_information.contract_type')}
        </Text>
      </Box>
      {contractType && (
        <Text size="300" weight="medium" color="grey1000">
          {contractType}
        </Text>
      )}
      {!contractType && (
        <Text size="300" weight="medium" color="grey600">
          {i18n.t('contract_versions.contract_information.not_informed')}
        </Text>
      )}
    </Box>
  )
}

export default observer(ContractType)
